"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var matchArray = /[^\[\]]+|\[\]/g;
var matchInteger = /^\d+$/;
var temp = [];
/**
 * @description
 * A setter for querystring style fields like "a[b][c]".
 * The setter will create arrays for repeat keys and supports the "[]" push syntax.
 *
 * @example
 * deep({}, "a[b][c]", 1) // { a: { b: { c: 1 } } }
 *
 * @param obj The object to set a value on.
 * @param path The querystring path to set.
 * @param value The value to set at the path.
 */
function deep(obj, path, value) {
    var keys = path === "" ? [""] : path.match(matchArray);
    var len = keys.length;
    var cur = obj;
    var prev;
    var key;
    var exists;
    for (var i = 0; i < len; i++) {
        prev = cur;
        key = keys[i];
        var next = keys[i + 1];
        if (key === "[]") {
            key = cur.length;
        }
        // Make path as we go.
        cur = (exists = typeof cur === "object" && key in cur)
            ? cur[key]
            : // Check if the next path is an explicit array.
                (cur[key] = next === "[]" || matchInteger.test(next) ? [] : {});
    }
    prev[key] = exists ? temp.concat(cur, value) : value;
    return obj;
}
exports.deep = deep;
/**
 * @description
 * Appends to an object using query string syntax with "[]" syntax push support.
 *
 * @example
 * shallow({}, "a[b][c]", 1) // { "a[b][c]": 1 }
 * shallow({}, "a[]", 1) // { a: [1] }
 *
 * @param obj The object to set a value on.
 * @param path The querystring path to set.
 * @param value The value to set at the path.
 */
function shallow(obj, key, val) {
    key = arrayPushIndexes(obj, key);
    obj[key] = key in obj ? temp.concat(obj[key], val) : val;
    return obj;
}
exports.shallow = shallow;
/**
 * Given a qs style key and an object will convert array push syntax to integers.
 * Eg: a[b][] -> a[b][0]
 */
function arrayPushIndexes(obj, key) {
    var path = key.split("[]");
    if (path.length === 1) {
        return key;
    }
    var cur = path[0];
    var keys = Object.keys(obj);
    for (var i = 1, len = path.length; i < len; i++) {
        cur += "[" + findLastIndex(keys, cur) + "]" + path[i];
    }
    return cur;
}
/**
 * Given a path to push to will return the next valid index if possible.
 * Eg: a[b][] -> 0 // if array is empty.
 */
function findLastIndex(keys, path) {
    var last = -1;
    for (var i = keys.length; i--;) {
        var key = keys[i];
        if (key.indexOf(path) !== 0) {
            continue;
        }
        var index = Number(key.replace(path, "").slice(1, key.indexOf("]") - 1));
        if (index > last) {
            last = index;
        }
    }
    return last + 1;
}
//# sourceMappingURL=index.js.map